<rask-container-block>
    @if (isLoading) {
    <ng-container header>
        <rask-header size="2" underline>
            Hämtar händelser
        </rask-header>
    </ng-container>
    }

    @if (isLoading) {
    <div class="list-container">
        <rask-busy-spinner size="5" class="spinner"></rask-busy-spinner>
    </div>
    }

    @if (!isLoading) {
    <ng-container header>
        <rask-header size="2" underline>
            {{ 'TPL_HANDELSER_HEADER' | translate }}
            @if (handelser) {
            <span class="small-text">{{ nrOfSelectedHandelser }} av {{ handelser.length }}
                valda</span>
            }
        </rask-header>
    </ng-container>
    }

    @if (handelser) {
    <div class="info-container">
        <rask-menu-button alignment="left" [template]="tpl" #menu>
        </rask-menu-button>
        <ng-template #tpl>
            <div class="menu-btn-container">
                <rask-action-button
                    class="col-12"
                    icon="fas fa-sync-alt"
                    aid="ta-bort"
                    [disabled]="!canMasshantera"
                    (click)="taBort()">Ta bort valda
                </rask-action-button>
            </div>
            <div class="menu-btn-container">
                <rask-action-button
                    class="col-12"
                    icon="fas fa-sync-alt"
                    aid="uppdatera-alla"
                    [disabled]="!canUppdateraAlla()"
                    (click)="uppdateraAlla()">Uppdatera alla
                </rask-action-button>
            </div>
        </ng-template>
        <rask-checkbox [(ngModel)]="allSelected" text="{{ 'TPL_LIST_SELECT_ALL' | translate }}"
            (checkedChange)="onAllSelectedChanged($event)" class="allCheckBox low"></rask-checkbox>
    </div>
    }

    @if (!isLoading) {
    <div class="list-container">
        @if (handelser.length === 0) {
        <div>
            Hittade inga aktuella händelser
        </div>
        }
        @if (handelser.length > 0) {
        <rask-cards class="card-container">
            @for (handelse of handelser; track handelse) {
            <div class="card-border">
                @if (handelse.hasWarningsOrErors) {
                <div class="row">
                    <rask-message-panel
                        class="col-12"
                        [numberOfItemsToDisplay]="5"
                        [maxNumOfRows]="2"
                        [items]="handelse.alerts"
                        [labels]="messageLabels">
                    </rask-message-panel>
                </div>
                }
                <div class="row">
                    <div class="col-10">
                        @if (handelse.isDirty) {
                        <div><i class="fas fa-sync"></i> Virkesordern behöver uppdateras
                        </div>
                        }
                    </div>
                    <div class="col-2">
                        <rask-checkbox (checkedChange)="onCheckedChanged($event)" class="checkbox low"
                            [(ngModel)]="handelse.selected"></rask-checkbox>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12" class="col-12 ao-name">
                        <a (click)="aoDetails($event, handelse.arbetsorderId)">
                            {{ handelse.arbetsorderBeteckning }} {{ handelse.arbetsorderNamn }}
                        </a>
                    </div>
                </div>
                <div class="row pb-3">
                    <div class="col-6 arbetsorder-info-colum">
                        <rask-label size="12">Länk till produktionsplanering</rask-label>
                        <div class="row">
                            <div>
                                <a href="planera/{{handelse.arbetsorderId}}" target="_blank" class="ppLink">
                                    {{ handelse.arbetsorderBeteckning }}
                                </a>
                                <div class="icon-container table-cell table-cell-icons">
                                    <div>
                                        <i aria-hidden="true" [ngClass]="getIkonVirkesorderstatus(handelse)"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                        @if (handelse.viol3) {
                        <div class="icon-container table-cell table-cell-icons preview-position">
                            <a [routerLink]="['/viol3/preview', handelse.arbetsorderId]" target="_blank">
                                Se Violinformation
                            </a>
                        </div>
                        }
                    </div>
                    <div class="col-6 viol3-send-button">
                        @if (!handelse.viol3) {
                        <rask-button
                            class="col-3 text-center btn-max-width"
                            color="secondary"
                            [disabled]="!handelse.canSendToViol()"
                            (click)="sendToViol(handelse)">
                            @if (handelse.pending) {
                            <rask-busy-spinner
                                size="1">
                            </rask-busy-spinner>
                            }
                            @if (handelse.pending) {
                            <span>Uppdaterar</span>
                            }
                            @if (!handelse.pending && handelse.skickad) {
                            <span>Uppdatera VIOL</span>
                            }
                            @if (!handelse.pending && !handelse.skickad) {
                            <span>Skicka till VIOL</span>
                            }
                        </rask-button>
                        }
                        @if (handelse.viol3) {
                        <rask-arbetsorder-viol3-button #viol3Button [arbetsorder]="handelse"
                            [overriddenValidationRules]="handelse.overrideValidationRules">
                        </rask-arbetsorder-viol3-button>
                        }
                        @if (handelse.skickad && !handelse.viol3) {
                        <p class="float-start" class="col-12 vo-sent-text">Senast skickad: {{
                            setSkickadDatum(handelse.skickad) }}</p>
                        }
                    </div>
                    @if (virkesorderService.showSendVoError(handelse.skickad, handelse.antalAktivaVirkesorderrader)) {
                    <div
                        class="col-12">
                        <rask-validation-message-row
                            [message]="virkesorderService.getSendVoErrorText(handelse.skickad, handelse.antalAktivaVirkesorderrader)"
                            type="error">
                        </rask-validation-message-row>
                    </div>
                    }
                </div>
            </div>
            }
        </rask-cards>
        }
    </div>
    }
</rask-container-block>